import { render, staticRenderFns } from "./ResearchIncomeDownload.vue?vue&type=template&id=7d7f675d&scoped=true&"
import script from "./ResearchIncomeDownload.vue?vue&type=script&lang=js&"
export * from "./ResearchIncomeDownload.vue?vue&type=script&lang=js&"
import style0 from "./ResearchIncomeDownload.vue?vue&type=style&index=0&id=7d7f675d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7f675d",
  null
  
)

export default component.exports